import React from 'react';
import PropTypes from 'prop-types';
import CheckboxControl from '../components/Form/Controls/CheckboxControl';
import InfoTooltip from '../components/InfoTooltip';
import { formatClassName, pickDataAttributes } from '../Util';
import isEmpty from 'lodash/isEmpty';
import { kebabCase } from 'lodash';

const getDataAction = ({ children, label }) => {
  if (!(children || label)) return 'check-checkbox';

  return children ? `check-${kebabCase(children)}` : `check-${kebabCase(label)}`
}

const MaterialCheckbox = (props) => {
  const hasTooltip = !isEmpty(props.tooltip)
  const dataAttributes = pickDataAttributes(props, 'checkbox');
  if (!dataAttributes['data-action']) {
    dataAttributes['data-action'] = getDataAction(props);
  }

  const className = formatClassName([
    'checkbox',
    'col-form-label',
    props.className,
    { 'has-tooltip': hasTooltip }
  ])

  return (
    <>
      <CheckboxControl {...props} className={className} {...dataAttributes}>
        {props.children || props.label}
        <i className="input-helper" />
      </CheckboxControl>
      {hasTooltip && (
        <InfoTooltip
          {...props.tooltip}
        />
      )}
    </>
  );
};

MaterialCheckbox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string
  })
};

export default MaterialCheckbox;
